import { render, staticRenderFns } from "./Oferta.vue?vue&type=template&id=524215b2&"
import script from "./Oferta.vue?vue&type=script&lang=js&"
export * from "./Oferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports